import React from 'react';
import styles from './ConnectionStatusPopup.module.css';

type Props = {
    show: boolean;
    adapterStatus: boolean;
    adyenStatus: boolean;
    onClose: () => void;
};

const ConnectionStatusPopup: React.FC<Props> = ({show, adapterStatus, adyenStatus, onClose}) => {
    if (!show) return null;

    return (
        <div id="connection-status-popup" className="popup">
            <div className="popup-content">
                <h2>Connection Status</h2>
                <button className="close-btn" onClick={onClose}>X</button>
                <div className={styles['status-item']}>
                    <span className={styles['status-dot']} style={{color: adapterStatus ? 'green' : 'red'}}>●</span>
                    <span>
                        {'The connection to '}
                        <b> Adyen DPA Adapter </b>
                        {adapterStatus ? ' was successful.' : ' has failed.'}
                    </span>
                </div>
                <div className={styles['status-item']}>
                    <span className={styles['status-dot']} style={{color: adyenStatus ? 'green' : 'red'}}>●</span>
                    <span>
                        {'The connection to '}
                        <b>  Adyen Platform </b>
                        {adyenStatus ? ' was successful.' : ' has failed.'}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default ConnectionStatusPopup;